import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  QueryList,
  ViewChild,
  ViewChildren,
  OnInit,
} from '@angular/core'

import {
  ICON_TYPE,
  FocusDirective,
  FacetCollapseState,
} from '@spartacus/storefront'
import {
  Facet,
  FacetValue,
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Observable } from 'rxjs'
// import {
//   FacetCollapseState,
//   FacetGroupCollapsedState,
//   FacetList,
// } from '../facet.model';
import { ProductFacetService } from '../services/product-facet.service'
import { FacetService } from '../services/facet.service'
import { ActivatedRoute, Router } from '@angular/router'
@Component({
  standalone: false,

  selector: 'vs-category-facet',
  templateUrl: './category-facet.component.html',
  styleUrls: ['./category-facet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryFacetComponent implements OnInit {
  protected _facet: Facet
  state$: Observable<FacetCollapseState>
  @Input() expandIcon: ICON_TYPE = ICON_TYPE.EXPAND
  @Input() collapseIcon: ICON_TYPE = ICON_TYPE.COLLAPSE

  @HostBinding('class.multi-select') isMultiSelect: boolean

  @ViewChildren('facetValue') values: QueryList<ElementRef<HTMLElement>>
  @ViewChild(FocusDirective) keyboardFocus: FocusDirective
  params: any
  length: number
  public open = true
  less = false
  @Input()
  set facet(value: Facet) {
    this._facet = value
    this.isMultiSelect = !!value.multiSelect
    this.state$ = this.facetService.getState(value)
  }
  get facet(): Facet {
    return this._facet
  }

  @Input()
  catFacet$: Observable<any>

  topVisible: number = 5
  maxVisible: number = this.topVisible
  totalCatLength: number = 0

  constructor(
    protected facetService: FacetService,
    protected elementRef: ElementRef<HTMLElement>,
    protected cd: ChangeDetectorRef,
    public cmsService: CmsService,
    public router: Router,
    public routes: ActivatedRoute,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.catFacet$.subscribe(
      (res) => {
        this.totalCatLength = res.length
        console.log("categories: ", res);
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  openLink(event: KeyboardEvent) {
    ;(event.target as HTMLElement).click()
    event.preventDefault()
  }

  toggleGroup(event: UIEvent) {
    // const host: HTMLElement = this.elementRef.nativeElement;
    // const isLocked = this.keyboardFocus?.isLocked;

    // this.facetService.toggle(this._facet, this.isExpanded);
    this.open = !this.open
    // if (!isLocked || this.isExpanded) {
    //   host.focus();
    //   // we stop propagating the event as otherwise the focus on the host will trigger
    //   // an unlock event from the LockFocus directive.
    //   event.stopPropagation();
    // }
  }
  get isExpanded(): boolean {
    return this.values.first.nativeElement.offsetParent !== null
  }

  increaseVisibleValues(): void {
    // this.facetService.increaseVisibleValues(this.facet);
    this.less = true
    this.maxVisible = this.totalCatLength
  }

  /**
   * Decreases the number of visible values for the facet. This is delegated
   * to `facetService.decreaseVisibleValues`.
   */
  decreaseVisibleValues(): void {
    this.less = false
    // this.facetService.decreaseVisibleValues(this.facet);
    this.maxVisible = this.topVisible
  }

  getLinkParams(value: FacetValue) {
    return this.facetService.getLinkParams(value.query?.query.value)
  }
  fun(value) {}
  // decreaseVisibleValues() {
  //   this.maxVisible = this.topVisible;
  // }

  // increaseVisibleValues() {
  //   this.maxVisible = this.totalCatLength + 1;
  // }
}
